import { render, staticRenderFns } from "./index.vue?vue&type=template&id=063ea29a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=063ea29a&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=063ea29a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063ea29a",
  null
  
)

export default component.exports